import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore } from "redux-persist";
import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";

import rootReducer from "./root.reducer";

const sagaMiddleware = createSagaMiddleware();
const Middleware = [sagaMiddleware, thunk];

if (import.meta.env.VITE_NODE_ENV === "development") {
	// Middleware.push(logger)
}

// const persistConfig = {
//   key: "esrp",
//   storage: storage,
//   blackList: ["user","MicroSiteScoreReducer"],
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...Middleware)));

export const persistor = persistStore(store);

const exportStore = { store, persistor };

export default exportStore;
